import React, { Component } from 'react';
import PropTypes from 'prop-types';
import DatePicker from '../../DatePicker';
import { Form, Modal } from 'semantic-ui-react';
import moment from 'moment';
class EditSystemInfoMessageModal extends Component {
	constructor(props) {
		super(props);
		this.state = { ...props.item };
		this.onFieldChange = this.onFieldChange.bind(this);
		this.onReset = this.onReset.bind(this);
		this.onSave = this.onSave.bind(this);
	}
	componentDidUpdate(prevProps, prevState) {
		if (prevProps.item !== this.props.item) {
			this.setState(this.props.item);
		}
	}
	onReset(e) {
		this.setState({ isActive: true, message: '', start: null, end: null });
	}
	onSave(e) {
		const message = { ...this.state };
		const { onEdit } = this.props;
		onEdit(message);
	}
	onFieldChange(e, { name, value }) {
		this.setState({ [name]: value });
	}
	render() {
		const { open, onClose } = this.props;
		return (
			<Modal open={open} className='systemInfoMessage' onClose={onClose} closeIcon>
				<Modal.Header>Edit System Information Message</Modal.Header>
				<Modal.Content>
					<Form>
						<Form.Group>
							<Form.Input placeholder='System Information Message' name='message' label='System Information Message' onChange={this.onFieldChange} value={this.state.message || ''} />
							<Form.Field>
								<label>Effective</label>
								<DatePicker name='start' selected={this.state.start ? Date.parse(moment(this.state.start).format()) : null} onChange={this.onFieldChange} />
							</Form.Field>
							<Form.Field>
								<label>Expires</label>
								<DatePicker name='end' selected={this.state.end ? Date.parse(moment(this.state.end).format()) : null} onChange={this.onFieldChange} />
							</Form.Field>
						</Form.Group>
						<Form.Group>
							<Form.Button content='Reset' onClick={this.onReset} />
							<Form.Button primary content='Save' onClick={this.onSave} />
						</Form.Group>
					</Form>
				</Modal.Content>
			</Modal>
		);
	}
}

EditSystemInfoMessageModal.propTypes = {
	open: PropTypes.bool.isRequired,
	item: PropTypes.object,
	onEdit: PropTypes.func.isRequired,
	onClose: PropTypes.func.isRequired,
};

export default EditSystemInfoMessageModal;
